<template>
    <div class="image" v-if="isBackground" :style="url | bgImage"/>
    <img v-else
            :src="url"
            :srcset="srcset | srcset"
            :alt="alt">
</template>

<script>
    export default {
        props: {
            isBackground: {
                type: Boolean,
                default() {
                    return false;
                },
            },
            srcset: {
                type: Array,
                default() {
                    return [];
                },
            },
            url: {
                type: String,
                required: true,
            },
            alt: {
                type: String,
                required: true,
            },
        },
    };
</script>
